import {parseQueryParams} from 'mad-utils/lib/react';

interface FetchConfig {
    body: string;
    mode: string;
    method: string;
    credentials: string;
    headers: Record<string, string>;
}

const _fetch = window.fetch;
window.fetch = function() {
    const url = arguments[0] as string;
    const config = arguments[1] as FetchConfig;

    const newUrl = handleClinicPublicRequests(url, config);
    if (newUrl) arguments[0] = newUrl;

    return _fetch.apply(this, arguments);
};

const handleClinicPublicRequests = (url: string, _config: FetchConfig) => {
    const query = parseQueryParams<any>(window.location.search);
    if (
        url.includes('unlock-account') ||
        url.includes('forgot-password') ||
        url.includes('resend-verify-email')
    ) {
        if (!query)
            return;
            
        let prefix = 'sync.';
        switch (query.mode) {
            case 'demo':
                prefix = 'sync-cf2-demo.';
                break;
            case 'yukon':
                prefix = 'sync-cf2-yukon.'
                break;
            case 'novascotia':
                prefix = 'api.novascotia.flow.';
                break;
            default:
                prefix = query.mode ? `api.${query.mode}.flow.` :  'sync.';
                break;
        }

        return url.replace('sync.', prefix);
    } else return;
};
